import SingleSectionTable from './SingleSectionTable';

export default SingleSectionTable;
